import axios from "axios";
import { useEffect, useState } from "react";

export default function KursModule({ baseUrl, client, currentUser, setTab }: { baseUrl: string, client: any, currentUser: any, setTab: (tab: string) => void }) {
    const [upcomings, setUpcomings] = useState<any>([{}]);
    const [loading, setLoading] = useState(true);

    const getUpcommingEvents = async () => {
        try {
            const response = await axios.get(baseUrl + '/getUpcomingEvents', { params: { client_uid: client?.uid, token: currentUser?.token, filter: "today" } });

            if (response.data.status === "OK") {
                setUpcomings(response.data.data.events);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!client) return;

        getUpcommingEvents();
    }, [client, baseUrl, currentUser])

    const handleSeeAllClick = (to: string) => {
        localStorage.setItem("previousPage", "Dashboard");
        setTab(to);
    }
    return (
        <div className="xl:col-span-2 bg-white rounded-2xl border border-slate-100 p-6 shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-sm font-semibold">Kommende kurs & eventer</h2>
                <button onClick={() => handleSeeAllClick("Kurs & eventer")} className="text-xs text-indigo-600 hover:underline">Se alle</button>
            </div>

            {loading ? (
                <div className="flex items-center justify-center h-64 w-full">
                    <div className="flex flex-col items-center">
                        <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                        <p className="mt-3 text-gray-600 animate-pulse">Laster...</p>
                    </div>
                </div>
            ) : (
                <div className="space-y-3 h-[170px] overflow-y-auto">
                    {upcomings.length === 0 && (
                        <div className="flex items-center justify-between py-1 border-b border-slate-100">
                            <p className="text-sm">Ingen siste kures or eventer</p>
                        </div>
                    )}
                    {upcomings.map((up: any, i: number) => (
                        <div className="p-4 bg-slate-50 rounded-xl flex items-center justify-between">
                            <div>
                                <p className="font-medium text-sm">{up.title}</p>
                                <p className="text-[11px] text-slate-500">Live stream</p>
                            </div>
                            <span className="text-[11px] text-slate-600">I dag {up.formatted_start_date_time.split(" - ")[1]}</span>
                        </div>
                    ))}
                </div>
            )}


        </div>
    )
}